module.exports = __webpack_public_path__ + "static/img/ui-design_02.ae4c006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui-design_02.jpg
// module id = iOjC
// module chunks = 0